import React from 'react';

import { Box, COLORS, FontWeight, Text } from '@clutter/clean';

import { NoWrap } from '@shared/formatters/no_wrap';

import checkmarkIcon from '@images/icons/checkmark-teal.svg';
import sparkleIcon from '@images/illustrations/sparkle.svg';

const CheckedItem: React.FC<{ text: string }> = ({ text }) => (
  <Box.Flex gap="8px" alignItems="baseline">
    <img width={12} height={12} src={checkmarkIcon} alt="" draggable={false} />
    <Text.Callout>{text}</Text.Callout>
  </Box.Flex>
);

export const FreeStorageBanner: React.FC = () => (
  <Box.Flex
    background={COLORS.dust}
    border={`1px solid ${COLORS.sunshine}`}
    borderRadius="4px"
    padding="16px"
    flexDirection="column"
    gap="8px"
  >
    <Text.Body color={COLORS.tealDark} weight={FontWeight.Medium}>
      Your first month of storage{' '}
      <NoWrap>
        on us!&nbsp;
        <img
          width={25}
          height={20}
          src={sparkleIcon}
          alt=""
          draggable={false}
        />
      </NoWrap>
    </Text.Body>
    <CheckedItem text="Free storage for a month when you move with us" />
    <CheckedItem text="No minimum, no commitment" />
    <CheckedItem
      text="We’ll deliver the items you want and store the rest in one of our secure
        facilities. You can schedule subsequent returns whenever you are ready
        for the rest of your items."
    />
  </Box.Flex>
);
